/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Improve_NavInputs */

const en_how_we_work_improve_nav = /** @type {(inputs: How_We_Work_Improve_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep it useful`)
};

const lv_how_we_work_improve_nav = /** @type {(inputs: How_We_Work_Improve_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzturam noderīgu`)
};

/**
* | output |
* | --- |
* | "Keep it useful" |
*
* @param {How_We_Work_Improve_NavInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_improve_nav = /** @type {((inputs?: How_We_Work_Improve_NavInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Improve_NavInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_improve_nav(inputs)
	return en_how_we_work_improve_nav(inputs)
});